import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Política de Privacidad — CÓDIGO POST-RUPTURA

Última actualización: Marzo 2026

1. Información que Recopilamos
Recopilamos únicamente la información necesaria para procesar tu compra: nombre, dirección de correo electrónico y datos de pago procesados de forma segura a través de Mercado Pago.

2. Uso de la Información
Tu información personal se utiliza exclusivamente para:
• Procesar y entregar tu compra digital
• Enviar confirmaciones de pedido y acceso al producto
• Brindar soporte al cliente si lo solicitas

3. Protección de Datos
Implementamos medidas de seguridad estándar de la industria para proteger tu información personal. Los datos de pago son procesados directamente por Mercado Pago y nunca almacenamos información de tarjetas de crédito.

4. No Compartimos tu Información
No vendemos, alquilamos ni compartimos tu información personal con terceros bajo ninguna circunstancia.

5. Cookies
Utilizamos cookies esenciales para el funcionamiento del sitio. No utilizamos cookies de rastreo publicitario.

6. Tus Derechos
Puedes solicitar la eliminación de tus datos personales en cualquier momento contactándonos por correo electrónico.

7. Cambios en esta Política
Nos reservamos el derecho de actualizar esta política. Los cambios serán publicados en esta página.
`.trim();
const termsContent = `
Términos y Condiciones — CÓDIGO POST-RUPTURA

Última actualización: Marzo 2026

1. Producto Digital
CÓDIGO POST-RUPTURA es un producto digital (ebook en formato PDF) que se entrega de forma inmediata tras la confirmación del pago.

2. Acceso y Entrega
Al completar tu compra, recibirás acceso inmediato al producto a través de un enlace de descarga enviado a tu correo electrónico.

3. Política de Reembolso
Debido a la naturaleza digital e inmediata del producto, no se ofrecen reembolsos una vez que el acceso ha sido entregado. Te recomendamos leer toda la información de la página antes de realizar tu compra.

4. Uso Personal
El contenido adquirido es para uso personal y exclusivo del comprador. Queda prohibida la reproducción, distribución o reventa del material sin autorización expresa.

5. Propiedad Intelectual
Todo el contenido del ebook, incluyendo textos, estrategias y metodologías, está protegido por derechos de autor. La compra otorga una licencia de uso personal, no transferible.

6. Resultados
Los resultados pueden variar según cada persona. El contenido es de carácter informativo y educativo, y no sustituye el asesoramiento profesional de salud mental.

7. Limitación de Responsabilidad
CÓDIGO POST-RUPTURA proporciona herramientas y estrategias educativas. No nos hacemos responsables por decisiones personales tomadas en base al contenido del producto.

8. Jurisdicción
Estos términos se rigen por las leyes de la República Argentina.
`.trim();
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 border-t border-white/5 bg-charcoal-light" data-id="element-78">
        <div className="max-w-4xl mx-auto px-6 flex flex-col items-center gap-4" data-id="element-79">
          <div className="flex items-center gap-6" data-id="element-80">
            <button onClick={() => setActiveModal('privacy')} className="font-sans text-xs text-gray-500 hover:text-gold transition-colors duration-300 tracking-widest uppercase" data-id="element-81">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-82">|</span>
            <button onClick={() => setActiveModal('terms')} className="font-sans text-xs text-gray-500 hover:text-gold transition-colors duration-300 tracking-widest uppercase" data-id="element-83">
              Términos y Condiciones
            </button>
          </div>
          <p className="font-sans text-xs text-gray-600 tracking-widest uppercase" data-id="element-84">
            © {new Date().getFullYear()} CÓDIGO POST-RUPTURA. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-85">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-86">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-card border border-white/10 rounded-md w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-87">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-88">
                <h3 className="font-playfair text-xl text-gold" data-id="element-89">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-1 text-gray-400 hover:text-white transition-colors" data-id="element-90">
                  <X className="w-5 h-5" data-id="element-91" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 overflow-y-auto" data-id="element-92">
                <pre className="font-sans text-sm text-gray-400 leading-relaxed whitespace-pre-wrap" data-id="element-93">
                  {activeModal === 'privacy' ? privacyContent : termsContent}
                </pre>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}